import { Vector3 } from 'three';
import { EEntityType, IRotatedBoxPure } from '.';

export interface BaseEntity3dOptions {
  // 资源路径
  url?: string;

  // 变换
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: [number, number, number] | number;

  // 材质
  // material?: THREE.Material;
  // materialOverrides?: Record<string, THREE.Material>;

  // 阴影
  // castShadow?: boolean;
  // receiveShadow?: boolean;

  // // 动画
  // autoPlayAnimation?: string;
  // animationSpeed?: number;

  // // 物理
  // mass?: number;
  // physicsEnabled?: boolean;

  // // 调试
  // showBoundingBox?: boolean;
  // showAxesHelper?: boolean;

  // 自定义数据
  userData?: Record<string, any>;
}

export enum EEntityStatus {
  normal = 'normal',
  unnormal = 'unnormal',
  hover = 'hover',
  selected = 'selected',
  virtual = 'virtual'
}

export interface IModelEntityInfo {
  entityId: string;
  type: EEntityType;
  priority: number;
  containerType: EContainerType;
  transformType?: ETransformType;
  isTextInfo?: boolean;
}

export interface IIntersectedModelEntityInfo extends IModelEntityInfo {
  intersectPoint: Vector3;
}

export enum EContainerType {
  intersectable = 'intersectable', // 参与碰撞检测的容器
  noIntersectable = 'noIntersectable', // 不参与碰撞检测的容器， 优先级比intersectable高，
  entity = 'entityContainer' // entity容器，参与碰撞检测
}

export enum ETransformType {
  Empty = 'empty',
  Rotation = 'rotation',

  ScaleLeft = 'scaleLeft',
  ScaleRight = 'scaleRight',
  ScaleTop = 'scaleTop',
  ScaleBottom = 'scaleBottom',
  ScaleLeftTop = 'scaleLeftTop',
  ScaleLeftBottom = 'scaleLeftBottom',
  ScaleRightTop = 'scaleRightTop',
  ScaleRightBottom = 'scaleRightBottom'
}

export enum EEntityStatus2 {
  Default = 'default',
  DrawNormal = 'drawNormal',
  DrawUnnormal = 'drawUnnormal',
  Hover = 'hover',
  Selected = 'selected'
}

export interface IBoxesEntityParams {
  boxes: IRotatedBoxPure[];
  linewidth: number;
  color: number;
  x: number;
  y: number;
  z: number;
  rotation: number;
  renderOrder?: number;
}
